import { Signal } from "@lit-labs/signals";
import type { MessageSegment } from "api-contracts/rpc/creator-message";
import type {
  IWritableCreatorMessageFormState,
  ICreatorMessageFormState,
  CreatorMessageFormData,
  CreatorMessageFormErrors,
} from "./types";

const DEFAULT_FORM_DATA: CreatorMessageFormData = {
  title: "",
  content: "",
  segments: [],
  ctaEnabled: false,
  ctaText: "",
  ctaUrl: "",
  scheduledAt: "",
  scheduledTime: "",
  scheduleEnabled: false,
  imageFileId: "",
  imageUrl: "",
};

export class CreatorMessageFormState implements IWritableCreatorMessageFormState {
  readonly formData = new Signal.State<CreatorMessageFormData>({ ...DEFAULT_FORM_DATA });
  readonly validationErrors = new Signal.State<CreatorMessageFormErrors>({});
  readonly isSubmitting = new Signal.State<boolean>(false);
  readonly isLoading = new Signal.State<boolean>(false);
  readonly messageId = new Signal.State<string | undefined>(undefined);
  readonly messageStatus = new Signal.State<string | undefined>(undefined);
  readonly availableSegments = new Signal.State<MessageSegment[]>([]);
  readonly segmentsLoading = new Signal.State<boolean>(false);
  readonly testSendEnabled = new Signal.State<boolean>(false);
  readonly testRecipientEmails = new Signal.State<string>("");
  readonly isSendingTest = new Signal.State<boolean>(false);

  reset(): void {
    this.formData.set({ ...DEFAULT_FORM_DATA });
    this.validationErrors.set({});
    this.isSubmitting.set(false);
    this.isLoading.set(false);
    this.messageId.set(undefined);
    this.messageStatus.set(undefined);
    this.availableSegments.set([]);
    this.segmentsLoading.set(false);
    this.testSendEnabled.set(false);
    this.testRecipientEmails.set("");
    this.isSendingTest.set(false);
  }
}

export function asReadonlyCreatorMessageFormState(state: CreatorMessageFormState): ICreatorMessageFormState {
  return state as ICreatorMessageFormState;
}
